import {isNumber} from 'lodash';
import {useCallback, useEffect, useState} from 'react';
import {useMemoizedValue} from '../../../../misc/useMemoizedValue';

export function useHorizontallyDraggableElement(containerSize, sliderSize, tabPositions, centerIndex) {
    const [leftPosition, setLeftPosition] = useState(0),
        [moving, setMoving] = useState(null), // will contain dragStart event or null
        hardLimit = [0, -1 * (sliderSize[0] - containerSize[0])],
        softLimit = [50, hardLimit[1] - 50],
        [keepCentered, setKeepCentered] = useState(true),
        canSlide = sliderSize[0] > containerSize[0];

    // Handle using selectedIndex to adjust the slider position ------------------------------------------------------------------------------
    useEffect(() => {
        setKeepCentered(true);
    }, [centerIndex]);
    useEffect(() => {
        if (isNumber(centerIndex) && keepCentered) {
            if (tabPositions[centerIndex] && tabPositions[centerIndex + 1]) {
                setLeftPosition((-1 * (tabPositions[centerIndex] + tabPositions[centerIndex + 1])) / 2 + containerSize[0] / 2);
            } else {
                setLeftPosition(-1 * tabPositions[centerIndex] ?? 0);
            }
        }
    }, [centerIndex, tabPositions]);

    // Handle touch drag the slider ----------------------------------------------------------------------------------------------------------
    useEffect(() => {
        if (moving) {
            let {lastTouchX} = moving;

            function handleDrag(e) {
                e.stopPropagation();

                let x = (e.touches[0] || e).clientX,
                    diff = x - lastTouchX;

                if (diff) {
                    lastTouchX = x;
                    setLeftPosition(leftPosition => {
                        leftPosition += diff;
                        if (leftPosition < softLimit[1]) leftPosition = softLimit[1];
                        if (leftPosition > softLimit[0]) leftPosition = softLimit[0];
                        return leftPosition;
                    });
                }
            }

            function handleEndDragging() {
                setMoving(null);
            }

            window.addEventListener('touchmove', handleDrag);
            window.addEventListener('touchend', handleEndDragging, {once: true});

            return () => {
                window.removeEventListener('touchmove', handleDrag);
                window.removeEventListener('touchend', handleEndDragging);
            };
        } else {
            // look into tab positions and find the closest to the current leftPosition
            setLeftPosition(leftPosition => {
                let newLeftPosition = leftPosition;
                if (newLeftPosition < hardLimit[1]) {
                    newLeftPosition = hardLimit[1];
                }
                if (newLeftPosition > hardLimit[0]) {
                    newLeftPosition = hardLimit[0];
                }
                newLeftPosition =
                    tabPositions?.reduce(
                        (prev, curr) => (Math.abs(-curr - newLeftPosition) < Math.abs(-prev - newLeftPosition) ? curr : prev),
                        tabPositions[0]
                    ) ?? 0;
                return -newLeftPosition;
            });
        }
    }, [moving, tabPositions, containerSize, centerIndex]);

    const handleTouchStart = useCallback(
        e => {
            console.log('HERE')
            if (canSlide) {
                setMoving({lastTouchX: (e.touches[0] || e).clientX});
                setKeepCentered(false);
            }
        },
        [canSlide]
    );

    return {
        leftPosition: leftPosition,
        onTouchStart: handleTouchStart,
        isAtLeft: leftPosition >= hardLimit[0],
        isAtRight: leftPosition <= hardLimit[1],
        tabsInViewport: useMemoizedValue(
            tabPositions
                .map((value, index) => [index, value, tabPositions[index + 1] ?? sliderSize[0]])
                .filter(([, tabLeft, tabRight]) => tabLeft + leftPosition >= 0 && tabRight + leftPosition <= containerSize[0])
                .map(([index]) => index)
        ),
        canSlide,
    };
}
